/**
 * WEBAPP-036: ricerca clienti tollerante all'ordine nome/cognome.
 * Ogni token (parole separate da spazi) deve comparire come sottostringa nel testo normalizzato.
 * Esempio: "Mario Rossi" e "Rossi Mario" matchano lo stesso name "Rossi Mario".
 */

/**
 * Stesso trattamento lato client e parametro API: collassa tutti gli spazi Unicode
 * (`\s` + flag u) e rimuove zero‑width, così "rebesan␣" o "rebesan\u00A0" restano "rebesan".
 */
export function normalizeMemberSearchInput(raw) {
  return String(raw ?? '')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/\s+/gu, ' ')
    .trim();
}

function normalizeForSearch(s) {
  const t = normalizeMemberSearchInput(s);
  if (!t) return '';
  return t
    .normalize('NFKC')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/gu, ' ');
}

export function textMatchesSearchTokens(text, query) {
  const haystack = normalizeForSearch(text);
  const q = normalizeForSearch(query);
  if (!q) return true;
  const tokens = q.split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return true;
  return tokens.every((tok) => haystack.includes(tok));
}

/**
 * Un solo haystack (tutti i campi testuali noti): ogni token può matchare in qualsiasi campo
 * (ordine nome/cognome irrilevante; più tollerante dei match per campo separato).
 */
export function memberMatchesNameOrEmailSearch(member, searchTerm) {
  const q = normalizeMemberSearchInput(searchTerm);
  if (!q) return true;
  const haystack = [
    member.name,
    member.nome,
    member.cognome,
    member.email,
    member.username
  ]
    .filter((v) => v != null && String(v).trim() !== '')
    .join(' ');
  return textMatchesSearchTokens(haystack, q);
}
